module.exports = __webpack_public_path__ + "img/header-memoireRingsRosegold@2x.5aac2b7.webp";